<template>
    <page-content>
        <div slot="header">
            <h4 class="page-title-padding">角色权限设置</h4>
            <el-button type="primary" size="mini" @click="compileClick">新建</el-button>
        </div>
        <div slot="content">
            <el-table :data="tableData" style="width: 100%" v-loading="loading"  max-height="780">
                <el-table-column  prop="name" label="Name">
                </el-table-column>
                <el-table-column prop="description" label="Description">
                </el-table-column>
                <el-table-column label="Action">
                    <template slot-scope="scope">
                        <el-button @click="compileClick(scope)" type="text" size="small">编辑</el-button>
                        <el-button @click="getPermission(scope)" type="text" size="small" style="margin-left:20px">权限</el-button>
                        <el-button @click="getUserData(scope)" type="text" size="small" style="margin-left:20px">用户</el-button>
                        <el-popover
                            placement="top"
                            width="160"
                            v-model="scope.row.amand">
                            <p>确定删除吗？</p>
                            <div style="text-align: right; margin: 0">
                                <el-button size="mini" type="text" @click="scope.row.amand=false">取消</el-button>
                                <el-button type="primary" @click="deleteRole(scope)" size="mini">确定</el-button>
                            </div>
                            <el-button slot="reference" style="margin-left:20px;font-size:12px" type="text">删除</el-button>
                        </el-popover>
                    </template>
                </el-table-column>
            </el-table>
            <el-dialog :title="statusUser?'新建':'编辑('+compileData.name+')'" :visible.sync="dialogFormVisible" width="600px">
                <el-form :model="form" :rules="rules" ref="form">
                    <el-form-item prop="name" label="Name" :label-width="formLabelWidth">
                        <el-input v-model="form.name" style="width:350px"></el-input>
                    </el-form-item>
                    <el-form-item prop="description" label="Description" :label-width="formLabelWidth">
                        <el-input v-model="form.description" style="width:350px"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="setNewData" :loading="dialogLoading">确 定</el-button>
                </div>
            </el-dialog>
            <el-dialog :title="'权限('+permissionData.name+')'" :visible.sync="permissionVisible" width="600px">
                <div  class="perm_dialog_role">
                    <el-tree
                        :data="permission"
                        show-checkbox
                        node-key="id"
                        ref="tree"
                        v-loading="permissionLoading"
                        :props="defaultProps"
                        :default-expanded-keys="expandedPermission"
                        :default-checked-keys="checkedPermission"
                        >
                    </el-tree>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="permissionVisible = false">取 消</el-button>
                    <el-button type="primary" @click="setPermissionData">确 定</el-button>
                </div>
            </el-dialog>
            <div v-if="!userVisible" style="display: none;">
                <el-tree
                        :data="getUserList"
                        show-checkbox
                        node-key="key"
                        ref="user"
                        :props="defaultProps"
                        :default-checked-keys="checkedUser"
                    >
                </el-tree>
            </div>
            <el-dialog :title="'用户('+amendUserData.name+')'" :visible.sync="userVisible" width="600px">
                <div style="margin-bottom:20px;">
                    <el-input
                        placeholder="输入关键字进行过滤"
                        v-model="filterText">
                    </el-input>
                </div>
                <div  class="user_dialog_role">
                    <el-tree
                        :data="getUserList"
                        show-checkbox
                        node-key="key"
                        ref="userList"
                        :props="defaultProps"
                        :default-checked-keys="checkedUser"
                        :filter-node-method="filterNode"
                    >
                    </el-tree>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="userVisible = false">取 消</el-button>
                    <el-button type="primary" @click="setSetUserCheckList('userList');userVisible=false">确 定</el-button>
                </div>
            </el-dialog>
            <!-- 已选中用户列表 -->
            <el-dialog :visible.sync="userVisibleList" width="600px">
                <el-table
                v-loading="userLoading"
                :data="userCheckList"
                max-height="600"
                style="width: 100%;margin-top:-40px;">
                    <el-table-column prop="title" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="dele" header-align="center" align="center">
                        <template slot-scope="scope">
                            <el-button @click="deleteUserList(scope)" style="margin-left:20px;font-size:12px;color:#f56c6c" type="text">删除</el-button>
                    </template>
                    </el-table-column>
                </el-table>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="userVisibleList = false">取 消</el-button>
                    <el-button type="primary" @click="setUserData">确 定</el-button>
                </div>
                <div slot="title">
                    <span>{{'用户('+amendUserData.name+')'}}</span>
                    <el-button type="primary" size="mini" style="margin-left:20px" @click="userVisible=true;newUserList()">新增</el-button>
                </div>
            </el-dialog>
        </div>
    </page-content>
</template>
<script>
import pageContent from '@/components/pageContent'
export default {
    data(){
        return {
            tableData: [],
            loading:false,
            dialogLoading:false,
            userLoading:false,
            userVisibleList:false,
            permissionLoading:false,
            dialogFormVisible:false,
            permissionVisible:false,
            userVisible:false,
            statusUser:true,    //true:新建；false编辑
            compileData:'',     //编辑数据
            form:{
                name:'',
                description:'',
            },
            rules:{
                name:[{ required: true, message: '不能为空'}],
                description:[{ required: true, message: '不能为空'}]
            },
            formLabelWidth: '140px',
            permission:[],          //权限tree数据
            defaultProps: {
                children: 'children',
                label: 'title'
            },
            expandedPermission:[],  //Permission默认展开
            checkedPermission:[],   //Permission默认选中的节点
            permissionData:[],      //修改权限数据
            getUserList:[],         //用户列表
            checkedUser:[],         //user默认选中的节点
            amendUserData:[],       //修改用户数据
            userCheckList:[],       //已选中用户列表
            filterText:'',          //人员搜索
        }
    },
    watch:{
        filterText(val) {
            this.$refs.userList.filter(val);
        }
    },
    created(){
        this.getRoleList()
    },
    components:{
        pageContent
    },
    methods:{
        getRoleList(){      //列表
            this.loading=!this.loading;
            this.$http.get('/entrust/role').then((v)=>{
                const data=v.data.data;
                if(v.status===200){
                    this.tableData=data;
                    this.loading=!this.loading;
                }
            }).catch((v)=>{

            })
        },
        setNewData(){
            this.$refs['form'].validate((valid) => {
                if(valid){
                    this.dialogLoading=true;
                    if(this.statusUser){        //新建
                        this.$http.post('/entrust/role',this.form).then((v)=>{
                            this.setDialog(v)
                        }).catch((v)=>{
                            this.dialogLoading=false;
                        })
                    }else{                      //编辑
                        this.$http.put('/entrust/role',{...this.form,id:this.compileData.id}).then((v)=>{
                            this.setDialog(v)
                        }).catch((v)=>{
                            this.dialogLoading=false;
                        })
                    }
                }
            })
        },
        setDialog(v){//新建及编辑dialog
            if(v.status===200){
                this.$message({message:v.data.message,type:'success'});
                this.getRoleList();
                this.dialogFormVisible=false;
            }
            this.dialogLoading=false;
            this.$refs['form'].resetFields();
        },
        getPermission(scope){           //权限
            this.permissionVisible=!this.permissionVisible;
            this.permissionData=scope.row;
            this.permissionLoading=true;
            if(this.permission.length<=0){
                this.$http.get('entrust/permission/tree').then((v)=>{
                    if(v.status===200){
                        this.permission=[];
                        v.data.data.forEach(v => {
                            this.permission.push({
                                ...v,
                                key:v.title
                            })
                        });
                        this.getCheckPermission(scope);
                    }
                }).catch((v)=>{ this.permissionLoading=false; })
            }else{
                this.getCheckPermission(scope);
            }
            
        },
        getCheckPermission(scope){ //权限选中
            this.permissionLoading=false;
            this.$http.get('entrust/role/permission',{params:{id:scope.row.id}}).then((v)=>{
                if(v.status === 200){
                    this.checkedPermission=[];
                    this.expandedPermission=[];
                    this.$refs.tree.setCheckedNodes([])
                    v.data.data.forEach(v => {
                        if(v.parent_id !== '/'){
                            this.$refs.tree.setChecked(v.id,true,true);
                        }else{
                            this.expandedPermission.push(v.id)
                            this.$refs.tree.setChecked(v.id,true)
                        }
                        
                    });
                }
            }).catch((v)=>{})
        },
        setPermissionData(){         //权限修改
            const param={
                roleId:this.permissionData.id,
                permissionId:this.$refs.tree.getCheckedKeys().concat(this.$refs.tree.getHalfCheckedKeys()),
            }
            this.$http.post('entrust/attach/permission',param).then((v)=>{
                if(v.status === 200){
                    this.permissionVisible=!this.permissionVisible;
                    this.$message({message:v.data.message,type:'success'});
                }
            }).catch((v)=>{})
        },
        getUserData(scope){     //获得用户列表
            this.userVisibleList=true;
            this.amendUserData=scope.row;
            this.userLoading=true;
            if(this.getUserList<=0){
                this.$http.get('entrust/getStaffAndOrganization').then((v)=>{
                    if(v.status === 200){
                        this.getUserList=v.data.data;
                        this.setUserCheck(scope)
                    }
                }).catch(()=>{})
            }else{
                this.setUserCheck(scope)
            }
            
        },
        setUserCheck(scope){            //获得选中用户
            this.checkedUser=[];
            this.$refs.user.setCheckedNodes([])
            
            this.$http.get('/entrust/staff/role',{params:{id:scope.row.id}}).then((v)=>{
                if(v.status === 200){
                    this.checkedUser=v.data.data;
                    this.setSetUserCheckList();
                }
            }).catch(()=>{})
        },
        setSetUserCheckList(data){          //选中用户列表
            this.$nextTick(()=>{
                let permArr=[];
                let param=[];
                this.$refs[data?data:'user'].getCheckedNodes().forEach((v)=>{
                    if(!v.children){
                        permArr.push({key:v.key,title:v.title});
                        param.push(v.key)
                    }
                })
                this.userCheckList=permArr;
                this.checkedUser=param;
                this.userLoading=false;
            })
        },
        filterNode(value, data) {           //用户搜索
            if (!value) return true;
            return data.title.toUpperCase().indexOf(value.toUpperCase()) !== -1;   //不区分大小写
            // return data.title.indexOf(value) !== -1;
        },
        newUserList(){                      //新增用户
            this.$nextTick(()=>{
                this.$refs.userList.setCheckedKeys(this.checkedUser)
            })
        },
        deleteUserList(scope){               //用户列表删除
            let param=[];
            const userCheckList=[...this.userCheckList]
            userCheckList.forEach((v,index)=>{
                if(v.key === scope.row.key){
                    this.userCheckList.splice(index,1)
                }else{
                    param.push(v.key)
                }
            })
            this.checkedUser=param;
        },
        setUserData(){                      //发送修改选中用户
            let permArr=[];
            this.userCheckList.forEach((v)=>{permArr.push(v.key);})
            const param={
                roleId:this.amendUserData.id,
                userId:permArr,
            }
            this.$http.post('entrust/attach/role',param).then((v)=>{
                this.userVisibleList=false;
                this.$message({message:v.data.message,type:'success'});
            }).catch(()=>{})
        },
        deleteRole(scope){              //删除角色
            this.$http.delete('entrust/role',{params:{id:scope.row.id}}).then((v)=>{
                if(v.status === 200){
                    this.$message({message:v.data.message,type:'success'});
                    this.getRoleList();
                }
            })
        },
        compileClick(v){
            this.dialogFormVisible=!this.dialogFormVisible;
            if(v.row){
                this.compileData=v.row;
                this.statusUser=false;
                this.form={...v.row};
            }else{
                this.statusUser=true;
                this.form={
                    name:'',
                    description:'',
                }
            }
        },
    }
}
</script>
<style scoped>
    
</style>

